// ** Third Party Imports
import { NavLink, useNavigate } from 'react-router-dom'

// ** React Imports
import { useEffect, useState } from 'react'

// ** Component Imports
import { ButtonPublic, IconButton } from '@/shared/ui'

// ** Icon Imports
import { LogoNew, Menu, XIcon } from '@/shared/ui/icons'

// ** Styled Components
import {
	InnerWrapper,
	LinksGroup,
	MenuIcon,
	NavbarWrapper,
	StyledSpan,
	MobileMenu,
	MobileMenuHeader,
	MobileMenuLinks,
	MobileMenuLink
} from './styles'

export const NavbarNew = () => {
	const navigate = useNavigate()
	const [isMobile, setIsMobile] = useState(false)
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

	const isNotHome = !['/home', '/home/'].includes(location.pathname)

	const scrollToSection = (id: string) => {
		const section = document.getElementById(id)

		if (section) {
			section.scrollIntoView({ behavior: 'smooth' })
			window.history.replaceState(null, '', `#${id}`)
		}
	}

	const handleScroll = (id: string) => {
		if (window.location.pathname !== '/home') {
			navigate('/home', { replace: false })

			setTimeout(() => {
				scrollToSection(id)
			}, 300)
		} else {
			scrollToSection(id)
		}
		// close mobile menu after navigation
		setIsMobileMenuOpen(false)
	}

	const handleMobileMenuToggle = () => {
		setIsMobileMenuOpen(!isMobileMenuOpen)
	}

	const handleMobileMenuClose = () => {
		setIsMobileMenuOpen(false)
	}

	// check screen size
	useEffect(() => {
		const checkScreenSize = () => {
			setIsMobile(window.innerWidth < 768)
		}

		checkScreenSize() // check on mount
		window.addEventListener('resize', checkScreenSize)

		return () => {
			window.removeEventListener('resize', checkScreenSize)
		}
	}, [])

	// prevent body scroll when mobile menu is open
	useEffect(() => {
		if (isMobileMenuOpen) {
			document.body.style.overflow = 'hidden'
		} else {
			document.body.style.overflow = 'unset'
		}

		// cleanup on unmount
		return () => {
			document.body.style.overflow = 'unset'
		}
	}, [isMobileMenuOpen])

	return (
		<>
			<NavbarWrapper $isNotHome={isNotHome}>
				<InnerWrapper $isNotHome={isNotHome}>
					{isMobile && (
						<MenuIcon
							icon={<Menu />}
							width={1.5}
							height={1.5}
							ariaLabel='Toggle hamburger menu'
							onClick={handleMobileMenuToggle}
						/>
					)}

					<IconButton
						className='logo'
						to='/home'
						icon={<LogoNew className='logo' />}
						width={10.5}
						height={3}
						ariaLabel='Go to home page'
					/>

					{!isMobile && (
						<LinksGroup>
							<NavLink className='link' to='/about'>
								About Us
							</NavLink>

							<StyledSpan
								className='link'
								onClick={() => {
									handleScroll('prices')
								}}
							>
								Prices
							</StyledSpan>

							<StyledSpan
								className='link'
								onClick={() => {
									handleScroll('faqs')
								}}
							>
								FAQs
							</StyledSpan>

							<ButtonPublic
								className='login-button'
								label='Sign In'
								variant='secondary'
								href='https://staging.fortunai.co/login'
							/>
						</LinksGroup>
					)}

					{isMobile && (
						<ButtonPublic
							className='login-button'
							label='Sign In'
							variant='secondary'
							href='https://staging.fortunai.co/login'
						/>
					)}
				</InnerWrapper>
			</NavbarWrapper>

			{/* Mobile Menu */}
			{isMobile && (
				<MobileMenu $isOpen={isMobileMenuOpen}>
					<MobileMenuHeader>
						<IconButton
							icon={<XIcon />}
							width={1.5}
							height={1.5}
							ariaLabel='Close mobile menu'
							onClick={handleMobileMenuClose}
						/>
					</MobileMenuHeader>

					<MobileMenuLinks>
						<MobileMenuLink
							as={NavLink}
							to='/about'
							onClick={handleMobileMenuClose}
						>
							About Us
						</MobileMenuLink>

						<MobileMenuLink
							onClick={() => {
								handleScroll('prices')
							}}
						>
							Prices
						</MobileMenuLink>

						<MobileMenuLink
							onClick={() => {
								handleScroll('faqs')
							}}
						>
							FAQs
						</MobileMenuLink>
					</MobileMenuLinks>
				</MobileMenu>
			)}
		</>
	)
}
